import { IntegrationIconProps } from './types';

const Tumbler = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2C8.27812 2 2 8.27812 2 16C2 23.7219 8.27812 30 16 30C23.7219 30 30 23.7219 30 16C30 8.27812 23.7219 2 16 2Z"
      fill="#021B33"
    />
    <path
      d="M14.5 7C14.5 9.82979 11 12 10 12V15H13V21C13 23.2091 14.7909 25 17 25H21V20.9574C20.605 20.9574 19.05 20.9574 17.9992 20.9574C17.447 20.9574 17 20.5097 17 19.9574V15H21V11H17V7H14.5Z"
      fill="white"
    />
  </svg>
);
export default Tumbler;
